import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { downloadLink } from '@/utils/helper';
import { $http } from '@/axios';

// 查询崩溃日志列表
export const queryCrashes: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setCrashes', { ...state.list, loading: true });
    // const res: IPageData = await $http.post('/client/tracking/crash/search', payload);
    const res: IPageData = await $http.post('/v1/system/crashreport/pagelist', payload);
    commit('setCrashes', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setCrashes', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

export const downloadDumpMsg: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    // const res: { url: string } | null = await $http.post('/file/get', payload);
    const res: { url: string } | null = await $http.post('/v1/system/file/download', payload);
    downloadLink(res?.url || '');
  } finally {
    commit('setLoading', false);
  }
};

// 查询组织列表
export const queryCrashOrgs: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setCrashOrgs', { ...state.orgs, loading: true });
    // const res = await $http.post('/v1/data/system/org/searchenterepriseconciseinfo', {});
    const res = await $http.post('/v1/data/system/org/listfororgbaseinfo', {});
    commit('setCrashOrgs', { data: res });
  } catch (e) {
    commit('setCrashOrgs', { data: [] });
  }
};

// 查询用户列表(功能暂时被屏蔽)
/*export const queryCrashUsers: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setCrashUsers', { ...state.users, loading: true });
    // const res = await $http.post('/data/userormemberlist', payload);
    const res = await $http.post('/v1/data/baseinfo/user/list', payload);
    commit('setCrashUsers', { data: res });
  } catch (e) {
    commit('setCrashUsers', { data: [] });
  }
};*/
